module.exports = __webpack_public_path__ + "static/media/RV-03.d0fedc31.jpg";